module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-test page-testresult"
  }, [_c('div', {
    staticClass: "result__item"
  }, [_c('div', {
    staticClass: "result__item-leftside"
  }, [_c('router-link', {
    attrs: {
      "to": "/rating"
    }
  }, [_vm._v("\n                " + _vm._s(!_vm.Helpers.isTouch() ? 'Посмотреть рейтинг' : 'Рейтинг') + "\n            ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n                На главную\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "result__item-content"
  }, [_c('div', {
    staticClass: "content-main"
  }, [_vm._v("\n                вы прошли тест за "), _c('span', {
    staticClass: "minutes"
  }, [_vm._v(_vm._s(_vm.formatVal(_vm.testResult.time.min)) + ":" + _vm._s(_vm.formatVal(_vm.testResult.time.sec)))]), _vm._v(" минут"), _c('br'), _vm._v("\n                и набрали "), _c('span', {
    staticClass: "balls"
  }, [_vm._v(_vm._s(_vm.testResult.score))]), _vm._v(" баллов."), _c('br', {
    staticClass: "mobile"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-social"
  }, [_c('div', {
    staticClass: "content-social__text"
  }, [_vm._v("\n                    Поделитесь результатом:\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "social-list"
  }, [_c('li', {
    staticClass: "social-item"
  }, [_c('a', {
    staticClass: "social-link tw",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.share('tw')
      }
    }
  }, [_c('tw')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "social-item"
  }, [_c('a', {
    staticClass: "social-link fb",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.share('fb')
      }
    }
  }, [_c('fb')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "social-item"
  }, [_c('a', {
    staticClass: "social-link vk",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.share('vk')
      }
    }
  }, [_c('vk')], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96d290a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/TestResult.vue
// module id = 510
// module chunks = 1